import PropTypes from 'prop-types'
import { useState } from 'react'
import { useDropzone } from 'react-dropzone'
import { toast } from 'react-toastify'
import { toastErrorLog } from '../../../helpers/toastErrorLog'

import * as archivoService from '../../servicios/archivoAdjuntoService'
import styles from './Upload.module.css'

const LIMIT_UPLOAD = 10

export const SubirArchivo = ({
  idUsuario,
  accept,
  idTipo,
  idDoc,
  onCarga,
  adjuntoPendiente = [],
  maxFiles = LIMIT_UPLOAD
}) => {
  const [archivoCargado, setArchivoCargado] = useState(null)
  const [subiendo, setSubiendo] = useState(false)

  const upload = async (archivo) => {
    try {
      setSubiendo(true)
      const idDocValue = Number(idDoc) || 0
      const formData = new FormData()
      formData.append('nombre', archivo.name)
      formData.append('idUsuario', idUsuario)
      formData.append('archivo', archivo)
      formData.append('idTipo', idTipo)
      formData.append('idDoc', idDocValue)
      formData.append('idPath', String(idDocValue))

      const adjunto = await archivoService.subirArchivo(formData)

      setArchivoCargado(archivo.name)
      await fetchAdjunto(adjunto.data.adjunto.idAdjunto)
    } catch (error) {
      const mensaje = 'Error al subir el archivo.'
      toastErrorLog(error, mensaje, 'upload')
    } finally {
      setSubiendo(false)
    }
  }

  const fetchAdjunto = async (idAdjunto) => {
    const adjunto = await archivoService.buscarAdjuntosPorId(idAdjunto)

    const adjuntos = {
      ...adjunto,
      data: {
        ...adjunto.data,
        idAdjunto: idAdjunto
      }
    }

    onCarga?.(adjuntos)
  }

  const onDrop = (acceptedFiles) => {
    if (!acceptedFiles.length) {
      return
    }

    const adjuntos = Array.isArray(adjuntoPendiente) ? adjuntoPendiente : []
    const espacioDisponible = maxFiles - adjuntos.length

    if (espacioDisponible <= 0) {
      toast.error(`No puedes subir más archivos. Límite: ${maxFiles}`)
      return
    }

    if (acceptedFiles.length > espacioDisponible) {
      toast.error(
        `Solo puedes subir ${espacioDisponible} archivo${espacioDisponible !== 1 ? 's' : ''} más de los ${acceptedFiles.length} seleccionados`
      )
    }

    const archivosACargar = acceptedFiles.slice(0, espacioDisponible)
    archivosACargar.forEach((file) => upload(file))
  }

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept,
    multiple: maxFiles > 1
  })

  return (
    <div
      {...getRootProps()}
      className={`${styles.dropzone} ${isDragActive ? styles.dropzoneActive : ''}`}
    >
      <input {...getInputProps()} />
      <i className="fa fa-file-upload fa-3x" />
      <p className={styles.fileName}>
        {archivoCargado
          ? `Archivo cargado: ${archivoCargado}`
          : subiendo
            ? 'Subiendo archivos...'
            : 'Arrastrá o hacé clic para subir tus archivos'}
      </p>
      {!subiendo && (
        <p className={styles.hint}>
          Podés arrastrar los archivos o seleccionarlos desde tu computadora.
        </p>
      )}
    </div>
  )
}

SubirArchivo.propTypes = {
  idUsuario: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  accept: PropTypes.object,
  idTipo: PropTypes.string.isRequired,
  idDoc: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onCarga: PropTypes.func,
  adjuntoPendiente: PropTypes.array.isRequired,
  maxFiles: PropTypes.number
}

SubirArchivo.defaultProps = {
  adjuntoPendiente: []
}
